import { createElementFromHTML } from './utils'

interface IOptions {
  inputEl?: HTMLInputElement
  inputElManualClick?: boolean
}

const htmlTemplate = `<input
  style="
    position:absolute;top:0px;left:0px;
    display:block;width:1px;height:1px;
    overflow:hidden;
  "
  type="file"
  accept="image/*"
  capture="user"/>`

let innerInputEl: null | HTMLInputElement = null

export default function(options: IOptions = {}): Promise<File> {
  const { inputEl, inputElManualClick } = options
  const skipCurInputElClick = inputEl && inputElManualClick
  const curInputEl = getInputEl(options)

  return new Promise((resolve, reject) => {
    // delInnerInputEl()
    curInputEl.onchange = e => {
      const files = curInputEl.files
      // console.log('formInout', curInputEl, files)
      const file = files ? files[0] : null
      if (!file) {
        reject(new Error('Invalid File'))
        return
      }
      curInputEl.onchange = null
      resolve(file);
      (e.target as HTMLInputElement).value = ''
    }
    if (!skipCurInputElClick) {
      curInputEl.click()
    }
  })
}

export function delInnerInputEl() {
  if (!innerInputEl) {
    return
  }
  document.body.removeChild(innerInputEl)
  innerInputEl = null
}

export function warmUpInnerInputEl() {
  getInputEl({})
}

function getInputEl(options: IOptions) {
  const { inputEl } = options
  if (inputEl) {
    return inputEl
  }
  if (!innerInputEl) {
    innerInputEl = createElementFromHTML<HTMLInputElement>(htmlTemplate)
    document.body.appendChild(innerInputEl)
  }
  return innerInputEl
}
